export const englishCrmMessages = {
  resources: {
    companies: {
      name: "Company |||| Companies",
      forcedCaseName: "Company",
      fields: {
        name: "Company name",
        website: "Website",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of contacts",
        revenue: "Revenue",
        sector: "Sector",
        size: "Size",
        tax_identifier: "Tax Identifier",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        context_links: "Context links",
        sales_id: "Account manager",
      },
      empty: {
        description: "It seems your company list is empty.",
        title: "No companies found",
      },
      import: {
        title: "Import companies",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
      },
      page: { create: "New company" },
      action: {
        create: "New company",
        edit: "Edit company",
        new: "New Company",
        show: "Show company",
      },
      added_on: "Added on %{date}",
      followed_by: "Followed by %{name}",
      followed_by_you: "Followed by you",
      no_contacts: "No contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} deal |||| %{smart_count} deals",
      related: {
        contacts: "Contacts",
        deals: "Deals",
        tasks: "Tasks",
        empty_contacts: "No contacts at this company yet",
        empty_deals: "No deals with this company yet",
        empty_tasks: "Its contacts have no pending tasks",
        add_contact: "Add contact",
        add_deal: "Add deal",
        show_all: "Show all (%{count})",
      },
      sizes: {
        one_employee: "1 employee",
        two_to_nine_employees: "2-9 employees",
        ten_to_forty_nine_employees: "10-49 employees",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employees",
        two_hundred_fifty_or_more_employees: "250 or more employees",
      },
      autocomplete: {
        create_error: "An error occurred while creating the company",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new company",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Background info",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
      },
      fields: {
        first_name: "First name",
        last_name: "Last name",
        last_seen: "Last seen",
        title: "Title",
        company_id: "Company",
        email_jsonb: "Email addresses",
        email: "Email",
        phone_jsonb: "Phone numbers",
        phone_number: "Phone number",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        has_newsletter: "Has newsletter",
        sales_id: "Account manager",
      },
      page: { create: "New contact" },
      action: {
        add: "Add contact",
        add_first: "Add your first contact",
        create: "New contact",
        edit: "Edit contact",
        export_vcard: "Export to vCard",
        new: "New Contact",
        show: "Show contact",
      },
      autocomplete: {
        create_item: "Create %{item}",
        create_label: "Start typing to create a new contact",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Followed by %{name}",
        followed_by_you: "Followed by you",
        status_none: "None",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      empty: {
        description: "It seems your contact list is empty.",
        title: "No contacts found",
      },
      import: {
        title: "Import contacts",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading contacts",
        select_contact: "Select %{name}",
      },
      bulk_tag: {
        action: "Tag",
        back: "Back to tags",
        create_description:
          "Create a new tag and apply it to the selected contacts.",
        description:
          "Choose an existing tag or create a new one for the selected contacts.",
        empty: "No tags yet. Create one to tag the selected contacts.",
        error: "Failed to add tag to contacts",
        removed:
          "Tag removed from %{smart_count} contact |||| Tag removed from %{smart_count} contacts",
        success:
          "Tag added to %{smart_count} contact |||| Tag added to %{smart_count} contacts",
        title: "Add tag to contacts",
      },
      merge: {
        action: "Merge with another contact",
        confirm: "Merge Contacts",
        current_contact: "Current Contact (will be deleted)",
        description: "Merge this contact with another one.",
        error: "Failed to merge contacts",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a contact to merge with",
        success: "Contacts merged successfully",
        target_contact: "Target Contact (will be kept)",
        title: "Merge Contact",
        warning_description:
          "All data will be transferred to the second contact. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
        will_reassign_notes:
          "%{smart_count} note will be reassigned |||| %{smart_count} notes will be reassigned",
        will_reassign_tasks:
          "%{smart_count} task will be reassigned |||| %{smart_count} tasks will be reassigned",
        will_update_deals:
          "%{smart_count} deal will be updated |||| %{smart_count} deals will be updated",
        will_add_emails:
          "%{smart_count} email address will be added |||| %{smart_count} email addresses will be added",
        will_add_phones:
          "%{smart_count} phone number will be added |||| %{smart_count} phone numbers will be added",
      },
      filters: {
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        managed_by_me: "Managed by me",
        search: "Search name, company...",
        this_week: "This week",
        today: "Today",
        tags: "Tags",
        tasks: "Tasks",
      },
      hot: {
        empty_change_status:
          'Change the status of a contact by adding a note to that contact and clicking on "show options".',
        empty_hint: 'Contacts with a "hot" status will appear here.',
        title: "Hot Contacts",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Description",
        company_id: "Company",
        contact_ids: "Contacts",
        categories: "Categories",
        amount: "Budget",
        expected_closing_date: "Expected closing date",
        stage: "Stage",
      },
      page: { create: "New deal" },
      action: {
        back_to_deal: "Back to deal",
        create: "New deal",
        new: "New deal",
      },
      field_categories: {
        misc: "Misc",
      },
      filters: {
        only_mine: "Only deals I manage",
      },
      archived: {
        action: "Archive",
        error: "Error: deal not archived",
        list_title: "Archived Deals",
        success: "Deal archived",
        title: "Archived Deal",
        view: "View archived deals",
      },
      inputs: {
        linked_to: "Linked to",
      },
      unarchived: {
        action: "Send back to the board",
        error: "Error: deal not unarchived",
        success: "Deal unarchived",
      },
      updated: "Deal updated",
      empty: {
        before_create: "before creating a deal.",
        description: "It seems your deal list is empty.",
        title: "No deals found",
      },
      import: {
        title: "Import deals",
      },
      invalid_date: "Invalid date",
      mobile: {
        new_short: "New",
        search: "Search deals",
        clear_search: "Clear search",
        filters: "Filters",
        filters_active:
          "%{smart_count} active filter |||| %{smart_count} active filters",
        all: "All",
        only_mine: "Only my deals",
        visible_stage: "Visible stage",
        sort_by: "Sort by",
        sort_amount: "Amount",
        sort_closing: "Closing date",
        sort_recent: "Recent",
        clear: "Clear",
        apply: "Apply",
        closing: "Closes %{date}",
        no_match: "No deals match these filters",
        stage_updated: "Stage updated",
        stage_update_error: "Could not update the stage",
        more_actions: "More actions",
        company_contacts: "Company and contacts",
        details: "Details",
        notes: "Notes",
        show_more: "Show more",
        show_less: "Show less",
        delivery: "Delivery",
      },
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Contact",
        deal_id: "Deal",
      },
      page: { create: "New note" },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "New note",
        create_for: "New note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      me: "Me",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a contact page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
      },
      actions: {
        attach_document: "Attach document",
      },
      validation: {
        note_or_attachment_required: "A note or an attachment is required",
      },
    },
    sales: {
      name: "User |||| Users",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        secondary_email: "Secondary email",
        secondary_emails: "Secondary emails",
        administrator: "Admin",
        disabled: "Disabled",
      },
      create: {
        error: "An error occurred while creating the user.",
        success:
          "User created. They will soon receive an email to set their password.",
        title: "New user",
      },
      edit: {
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "User updated successfully",
        title: "Edit %{name}",
      },
      page: { create: "New user" },
      action: {
        new: "New user",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Description",
        due_date: "Due date",
        type: "Type",
        contact_id: "Contact",
        due_short: "due",
      },
      page: { create: "New task" },
      action: {
        add: "Add task",
        create: "New task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "New task",
        create_for: "New task for %{name}",
      },
      sheet: {
        edit: "Edit task",
        edit_for: "Edit task for %{name}",
      },
      empty: "No tasks yet",
      empty_list_hint: "Tasks added to your contacts will appear here.",
      filters: {
        later: "Later",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
        with_pending: "With pending tasks",
      },
      regarding_contact: "(Re: %{name})",
      updated: "Task updated",
      // ---- internal tasks ----
      kind: {
        nav: "Team and clients",
        list_title: "Team and clients",
        label: "Task kind",
        internal: "Internal",
        client: "Project / Client",
        client_short: "Client",
        all: "All",
        filter_label: "Filter tasks by kind",
        assignee: "Assigned to",
        internal_hint: "For organizing the team, no contact.",
        client_hint: "Linked to a project or client contact.",
        contact_required: "Pick a contact for a project or client task",
        assignee_required: "Pick who the task is assigned to",
        assigned_to: "For %{name}",
        empty_internal: "No pending internal tasks.",
        empty_client: "No pending client tasks.",
      },
      // ---- end internal tasks ----
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "New tag",
      },
      dialog: {
        color: "Color",
        create_title: "New tag",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
      empty: "No tags yet.",
    },
    // ---- create-page titles of the hub resources (ra-core reads
    // resources.<name>.page.create); their other keys live in fretum/i18n.ts ----
    team_tasks: { page: { create: "New task" } },
    events: { page: { create: "New event" } },
    delivery_templates: { page: { create: "New delivery template" } },
    time_entries: { page: { create: "New time entry" } },
    styles: { page: { create: "New style" } },
    wiki_pages: { page: { create: "New page" } },
    subscriptions: { page: { create: "New cost" } },
    quotes: { page: { create: "New quote" } },
    invoices: { page: { create: "New invoice" } },
    // ---- end hub create-page titles ----
  },
  crm: {
    action: {
      reset_password: "Reset Password",
    },
    auth: {
      first_name: "First name",
      last_name: "Last name",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      sign_in_google_workspace: "Sign in with Google Workplace",
      link_error_details:
        "Invitation and password reset links can only be used once and expire after a while. Ask an administrator for a new invitation, or request a new link with “Forgot password?”.",
      link_expired_title: "This link has expired",
      link_invalid_title: "This link is not valid",
      request_new_link: "Request a new link",
      signup: {
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      welcome_title: "Welcome to Avante",
    },
    common: {
      account_manager: "Account manager",
      activity: "Activity",
      added: "added",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      close_notification: "Close notification",
      loading: "Loading...",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
      unnamed: "Unnamed",
    },
    empty_state: {
      title: "No %{name} yet",
      hint: "What you add will appear here.",
      filtered_title: "No results",
      filtered_hint: "No %{name} match the current filters.",
      clear_filters: "Clear filters",
      resources: {
        invoices: {
          title: "No invoices yet",
          hint: "Log your invoices to follow what is pending and what has been paid.",
        },
        quotes: {
          title: "No quotes yet",
          hint: "Prepare a quote for a client and follow its status.",
        },
        wiki_pages: {
          title: "The wiki is empty",
          hint: "Write down processes, guides and the team's know-how.",
        },
        subscriptions: {
          title: "No costs yet",
          hint: "Add subscriptions and recurring costs to see your monthly spend.",
        },
        time_entries: {
          title: "No hours logged",
          hint: "Log the time spent on tasks and deals.",
        },
        team_tasks: {
          title: "No team tasks",
          hint: "Create a task and assign it to someone on the team.",
        },
        delivery_templates: {
          title: "No delivery templates",
          hint: "A template creates the milestones of a deal in one go.",
        },
        styles: {
          title: "No styles yet",
          hint: "Save colors and fonts to reuse them in your projects.",
        },
        tasks: {
          title: "No tasks",
          hint: "Tasks you create will appear here.",
        },
        sales: {
          title: "No users",
          hint: "Invite the people on your team.",
        },
      },
    },
    style_preview: {
      label: "Style preview",
      button: "Button",
    },
    splash: {
      greeting: "Hi, %{name}",
    },
    pwa: {
      update_available: "A new version is available",
      update: "Update",
      later: "Not now",
    },
    changelog: {
      title: "What's new",
      subtitle: "The latest changes in Avante, newest first.",
      change_number: "Change %{number}",
      categories_label: "Categories",
      categories: {
        new: "New",
        mobile: "Mobile",
        desktop: "Desktop",
        fix: "Fix",
      },
    },
    activity: {
      added_company: "%{name} added company",
      you_added_company: "You added company",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      added_note_about_deal: "%{name} added a note about deal",
      you_added_note_about_deal: "You added a note about deal",
      added_deal: "%{name} added deal",
      you_added_deal: "You added deal",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      stepper: {
        install: "Install Avante",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
    },
    data_import: {
      button: "Import CSV",
      complete:
        "Import complete. Imported %{importCount} records, with %{errorCount} errors",
      csv_file: "CSV File",
      error:
        "Failed to import this file, please make sure you provided a valid CSV file.",
      in_progress: "Import in progress…",
      progress:
        "Imported %{importCount} / %{rowCount} records, with %{errorCount} errors.",
      remaining_time: "Estimated remaining time:",
      resource: "Resource",
      sample_download: "Download CSV sample",
      sample_hint: "Here is a sample CSV file you can use as a template",
      start: "Start import",
      stop: "Stop import",
      stopped:
        "Import stopped. Imported %{importCount} records, with %{errorCount} errors",
      title: "Import data",
    },
    header: {
      import_data: "Import from JSON",
    },
    search: {
      title: "Search",
      placeholder: "Search contacts, companies, deals, tasks and notes...",
      hint: "Type at least %{min} characters to search",
      empty: "No result found",
      error: "Search is unavailable right now. Please try again.",
      untitled_result: "(no title)",
      show_more: "Show more",
      cancel: "Cancel",
      clear_query: "Clear search",
      recent: "Recent",
      clear_recent: "Clear",
      clear_recent_label: "Clear recent searches",
      quick_links: "Go to",
      searching: "Searching…",
      empty_hint: "Try another name, company or keyword.",
      keys: { navigate: "navigate", open: "open", close: "close" },
      groups: {
        contacts: "Contacts",
        companies: "Companies",
        deals: "Deals",
        tasks: "Tasks",
        contact_notes: "Contact notes",
        deal_notes: "Deal notes",
      },
    },
    image_editor: {
      change: "Change",
      drop_hint: "Drop a file to upload, or click to select it.",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    import: {
      action: {
        download_error_report: "Download the error report",
        import: "Import",
        import_another: "Import another file",
      },
      error: {
        unable: "Unable to import this file.",
      },
      idle: {
        description_1:
          "You can import sales, companies, contacts, companies, notes, and tasks.",
        description_2:
          "Data must be in a JSON file matching the following sample:",
      },
      status: {
        all_success: "All records were imported successfully.",
        complete: "Import complete.",
        failed: "Failed",
        imported: "Imported",
        in_progress:
          "Import in progress, please don't navigate away from this page.",
        some_failed: "Some records were not imported.",
        table_caption: "Import status",
      },
      title: "Import from JSON",
    },
    settings: {
      about: "About",
      companies: {
        sectors: "Sectors",
      },
      dark_mode_logo: "Dark Mode Logo",
      deals: {
        categories: "Categories",
        currency: "Currency",
        pipeline_help:
          "Select which deal stages should count as pipeline deals.",
        pipeline_statuses: "Pipeline Statuses",
        stages: "Stages",
      },
      light_mode_logo: "Light Mode Logo",
      notes: {
        statuses: "Statuses",
      },
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      preferences: "Preferences",
      title: "Settings",
      app_title: "App Title",
      sections: {
        branding: "Branding",
      },
      validation: {
        duplicate: "Duplicate %{display_name}: %{items}",
        in_use:
          "Cannot remove %{display_name} that are still used by deals: %{items}",
        validating: "Validating\u2026",
        entities: {
          categories: "categories",
          stages: "stages",
        },
      },
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
      current: "Theme: %{theme}",
      switch_to: "Switch to %{theme}",
    },
    language: "Language",
    mobile: {
      search_placeholder: "Search project, task, event...",
      status_in_progress: "In progress",
      status_upcoming: "Upcoming",
      status_done: "Done",
      nav_home: "Home",
      nav_reports: "Reports",
      nav_tasks: "Tasks",
      nav_deals: "Deals",
      nav_market: "Market",
      nav_more: "More",
      nav_close: "Close",
      back: "Back",
      menu_title: "Sections",
      create: "Create",
      agenda: "Schedule",
      all_day: "All day",
      no_events: "Nothing scheduled",
      notifications: "Notifications",
      notifications_empty: "No recent activity",
      open_calendar: "Open schedule",
      reports_title: "Reports",
      reports_subtitle: "Open opportunities",
      week_previous: "Previous week",
      week_next: "Next week",
      agenda_view: "Schedule view",
      agenda_day: "Day",
      agenda_week: "Week",
      agenda_month: "Month",
      agenda_today: "Today",
      agenda_items: "%{smart_count} item |||| %{smart_count} items",
      day_previous: "Previous day",
      day_next: "Next day",
      month_previous: "Previous month",
      month_next: "Next month",
      deal_missing: "This opportunity is not available",
      no_deals: "No open opportunities",
      account: "Account and settings",
      account_group: "Account",
      admin_group: "Administration",
      crm_settings: "CRM settings",
      team_tasks: "Team tasks",
      close_settings: "Close settings",
      close_agenda: "Close schedule",
      close_notifications: "Close notifications",
      settings_title: "Settings",
      settings_back: "Back to settings",
      more: {
        title: "More",
        label: "Modules",
      },
      quick_actions: "Quick actions",
      plus: {
        new_task: "New task",
        new_note: "New note",
        go_to: "Go to",
      },
      all_stages: "All stages",
      reports_pipeline: "Open pipeline",
      reports_count: "%{smart_count} deal |||| %{smart_count} deals",
      reports_stage_filter: "Filter by stage",
      reports_list_title: "Deals",
      progress: "Progress",
      delivery_progress: "Delivery progress",
      stage_progress: "Progress by pipeline stage",
      kanban_empty_deals: "No deals",
      // Audit 2 navigation: quick agenda window, calendar, Más groups.
      calendar: "Calendar",
      more_groups: {
        crm: "CRM",
        hub: "Hub",
      },
      calendar_window: {
        open: "Open calendar",
        close: "Close calendar",
      },
    },
    navigation: {
      label: "CRM navigation",
    },
    profile: {
      add_secondary_email: "Add an email",
      email_taken: "%{email} is already used by another user",
      no_secondary_emails: "None",
      secondary_email_invalid: "%{email} is not a valid email address",
      secondary_email_is_primary: "%{email} is already your main address",
      secondary_email_taken: "%{email} is already used by another user",
      too_many_secondary_emails:
        "You cannot add more than 10 secondary email addresses",
      secondary_emails_help:
        "Other addresses you send emails from. Leave one empty to remove it.",
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. Avante will process the emails and add notes to the corresponding contacts.",
        title: "Inbound email",
      },
      mcp: {
        title: "MCP Server",
        description:
          "Use this URL to connect your AI assistant to your CRM data via the Model Context Protocol (MCP).",
        copy: "Copy MCP URL",
        copied: "MCP URL copied",
        copy_error: "Could not copy the MCP URL",
      },
      password: {
        change: "Change password",
      },
      password_reset_sent:
        "A reset password email has been sent to your email address",
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
    },
  },
  // ---- desk (desktop redesign): one sub-object per area ----
  desk: {
    // ---- desk.shell (sidebar, sheet header) ----
    shell: {
      nav: {
        all: "All",
        all_f: "All",
        pipeline: "Pipeline",
        won: "Won",
        lost: "Lost",
        pending: "Pending",
        done: "Done",
        agenda: "Agenda",
      },
      collapse: "Collapse sidebar",
      expand: "Expand sidebar",
      search_placeholder: "Search contacts, companies…",
      agenda_today:
        "Agenda: %{smart_count} item today |||| Agenda: %{smart_count} items today",
      more_actions: "More actions",
      refresh: "Refresh data",
      dark_mode: "Dark mode",
      settings: "Settings",
      account_menu: "Account menu",
      notifications: {
        title: "Notifications",
        overdue: "Overdue",
        today: "Today",
        see_all: "See tasks",
        empty: "Nothing due in the next 7 days.",
      },
      goal: {
        title: "Expected closes this month",
        percent_won: "%{percent}% won",
        won_prefix: "You have won",
        of: "of",
        expected_suffix: "expected this month.",
        empty: "No deal is expected to close this month.",
        cta: "View pipeline",
      },
    },
    // ---- end desk.shell ----
    // ---- desk.home (home views A «Hoy» / B «Pulso», desktop and mobile) ----
    home: {
      view_label: "Home view",
      views: { today: "Today", pulse: "Pulse" },
      more_title: "Team and deliveries",
      summary: {
        attention:
          "%{smart_count} thing needs your attention |||| %{smart_count} things need your attention",
        overdue: "%{smart_count} is overdue |||| %{smart_count} are overdue",
        all_clear: "all caught up",
      },
      counters: {
        label: "Today at a glance",
        overdue: "Overdue",
        today: "Today",
        no_next_step: "No next step",
        no_next_step_short: "No step",
        collect: "To collect",
        items: "item |||| items",
        deals: "deal |||| deals",
        oldest:
          "oldest one %{smart_count} day ago |||| oldest one %{smart_count} days ago",
        overdue_none: "nothing overdue",
        today_none: "nothing scheduled",
        no_next_step_hint: "%{amount} with no task or meeting",
        no_next_step_none: "every deal has a plan",
        collect_overdue: "%{amount} overdue",
        collect_none: "nothing overdue",
        parts: {
          events: "%{smart_count} event |||| %{smart_count} events",
          tasks: "%{smart_count} task |||| %{smart_count} tasks",
          milestones: "%{smart_count} milestone |||| %{smart_count} milestones",
        },
      },
      inbox: {
        title: "Needs your attention",
        subtitle: "sorted by urgency",
        empty: "Nothing pending. Nice work.",
        show_more: "Show %{smart_count} more",
        show_less: "Show less",
        done_notice: "Done: %{title}",
        done_error: "Could not update it, try again",
        kind_internal: "internal task",
        kind_client: "client task",
        team_task: "team task",
        milestone: "milestone",
        priority_high: "high priority",
        priority_urgent: "urgent",
        event_kinds: {
          meeting: "meeting",
          demo: "demo",
          call: "call",
          internal: "internal",
          deadline: "deadline",
          other: "event",
        },
        closing_passed: "expected close %{date} has passed",
        idle: "no activity for %{smart_count} day |||| no activity for %{smart_count} days",
        invoice_overdue:
          "overdue by %{smart_count} day |||| overdue by %{smart_count} days",
        invoice_due: "due %{date}",
        groups: {
          overdue: "Overdue",
          today: "Today",
          no_next_step: "Deals with no next step",
          collect: "Payments",
        },
        hints: {
          oldest:
            "oldest one %{smart_count} day ago |||| oldest one %{smart_count} days ago",
          at_stake: "%{amount} at stake",
          pending: "%{amount} pending",
        },
        chip: {
          yesterday: "yesterday",
          late: "%{smart_count} day ago |||| %{smart_count} days ago",
          today: "today",
          closing_late: "+%{smart_count} d",
          idle_days: "%{smart_count} d",
          invoice_late: "overdue %{smart_count} d",
        },
        actions: {
          done: "Done",
          done_label: "Mark “%{title}” as done",
          next_step: "Next step",
          next_step_short: "+ step",
          next_step_label: "Plan the next step for “%{title}”",
          move_date: "Move date",
          open_invoice: "See invoice",
          open: "Open",
        },
      },
      agenda: {
        title: "Today's agenda",
        week: "Week",
        all_day: "All day",
        more_all_day: "+%{smart_count} more all day",
        empty: "Nothing with a time today",
        now: "Now",
        now_label: "Now, %{time}",
        tomorrow:
          "Tomorrow: %{smart_count} item |||| Tomorrow: %{smart_count} items",
        see_all: "See agenda",
        sources: {
          task: "Task",
          event: "Event",
          team_task: "Team task",
          deal_closing: "Expected close",
          milestone: "Milestone",
          renewal: "Renewal",
          invoice_due: "Invoice due",
        },
      },
      collect: {
        title: "To collect",
        vat: "VAT incl.",
        collected_month: "+%{amount} collected this month",
        overdue_badge: "%{amount} overdue",
        overdue: "Overdue",
        dueThisWeek: "Due this week",
        later: "Later",
        empty: "Nothing pending collection",
        see_all: "Invoices",
      },
      quick: {
        title: "Quick actions",
        task: "Task",
        note: "Note",
        deal: "Deal",
        invoice: "Invoice",
        contact: "Contact",
        task_hint: "New task",
        note_hint: "New note",
        deal_hint: "New deal",
        invoice_hint: "New invoice",
        contact_hint: "New contact",
      },
      next: {
        empty: "Nothing else with a time this week",
        now: "now",
        in_minutes: "in %{smart_count} min",
        today: "Today",
        tomorrow: "Tomorrow",
      },
      mobile: {
        next: "Next",
        agenda: "Agenda",
        attention: "Needs attention",
        see_all: "See all",
        collect: "To collect",
        invoices: "Invoices",
      },
      pulse: {
        title: "Business pulse",
        subtitle: "live from your data",
        approx: "approx.",
        kpi: {
          label: "Business figures",
          pipeline: "Open pipeline",
          pipeline_hint:
            "%{smart_count} active deal |||| %{smart_count} active deals",
          won: "Won this month",
          won_approx:
            "Avante does not store the date a deal was won: this counts won deals whose expected close falls this month. “Expected closes” is not a target: it is the sum of the deals expected to close this month.",
          won_hint: "of %{amount} in expected closes",
          won_none: "no deal expected to close this month",
          won_ratio: "%{percent} of the expected closes",
          invoiced: "Invoiced",
          net: "excl. VAT",
          invoiced_hint:
            "%{month} · %{smart_count} invoice |||| %{month} · %{smart_count} invoices",
          invoiced_trend: "Invoiced over the last 6 months",
          outstanding: "Pending collection",
          outstanding_overdue: "%{amount} overdue",
          outstanding_hint:
            "%{smart_count} issued invoice · VAT incl. |||| %{smart_count} issued invoices · VAT incl.",
        },
        revenue: {
          title: "Revenue",
          subtitle: "invoiced vs collected, excl. VAT",
          legend: "Series",
          invoiced: "Invoiced",
          collected: "Collected",
          total_invoiced: "invoiced in 6 months",
          total_collected: "collected in 6 months",
          empty: "No invoices in the last 6 months",
          month_label: "%{month}: invoiced %{invoiced}, collected %{collected}",
          month: "Month",
        },
        funnel: {
          title: "Funnel by stage",
          subtitle: "open deals",
          empty: "No open deals",
          deals: "%{smart_count} deal |||| %{smart_count} deals",
          overdue_closings:
            "Expected close passed (%{smart_count}) |||| Expected close passed (%{smart_count})",
        },
        deliveries: {
          title: "Projects in delivery",
          active: "%{smart_count} active |||| %{smart_count} active",
          see_all: "See deals",
          empty: "No project in delivery",
          project: "Project",
          progress: "Progress",
          status: "Status",
          next: "Next milestone",
          milestones: "milestone %{done} of %{total}",
          today: "today",
        },
        hours: {
          title: "Hours · %{month}",
          billable: "%{percent} billable",
          empty: "No hours logged this month",
          logged: "logged this month",
          no_deal: "Internal · no deal",
        },
        costs: {
          title: "Fixed costs",
          subtitle: "subscriptions",
          active: "%{smart_count} active |||| %{smart_count} active",
          empty: "No active subscriptions",
          per_month: "/ month · %{yearly} / year",
          renewals: "Next renewals",
          periods: { monthly: "monthly", yearly: "yearly", one_off: "one-off" },
          see_all: "See costs",
        },
      },
      setting: {
        section: "Preferences",
        title: "Default home view",
        hint: "What you see when you open Avante on a computer. Saved in this browser.",
      },
    },
    // ---- end desk.home ----
  },
  // ---- end desk ----
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
